"use strict";

var React = require('react');

var TranslatedRoutesContext = React.createContext({});

var TranslatedRoutesProvider = function TranslatedRoutesProvider(_ref) {
  var translatedRoutes = _ref.translatedRoutes,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(TranslatedRoutesContext.Provider, {
    value: translatedRoutes
  }, children);
};

var useTranslatedRoutesContext = function useTranslatedRoutesContext() {
  return React.useContext(TranslatedRoutesContext);
};

module.exports = {
  TranslatedRoutesProvider: TranslatedRoutesProvider,
  useTranslatedRoutesContext: useTranslatedRoutesContext
};